import { ArrowDropDown } from "@mui/icons-material";
import {
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@mui/material";
import { ReactElement, useRef, useState } from "react";

import { SpinningCircle } from "./icons/SpinningCircle";

export const ButtonWithMenu = ({
  primaryButton,
  menuItems,
}: {
  primaryButton: ReactElement;
  menuItems: {
    key: string;
    label: string | ReactElement;
    onClick: (event: React.MouseEvent<HTMLLIElement, MouseEvent>) => void;
    disabled?: boolean;
    visible?: boolean;
    loading?: boolean;
  }[];
}): ReactElement => {
  const anchorRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);

  const visibleMenuItems = menuItems.filter(
    item => item.visible === undefined || !!item.visible
  );

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number
  ) => {
    visibleMenuItems[index]?.onClick(event);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      <ButtonGroup variant="contained" ref={anchorRef}>
        {primaryButton}
        <Button
          size="small"
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="menu"
          onClick={handleToggle}
        >
          <ArrowDropDown />
        </Button>
      </ButtonGroup>
      <Popper
        sx={{ zIndex: 1 }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {visibleMenuItems.map((option, index) => (
                    <MenuItem
                      key={option.key}
                      disabled={option.disabled}
                      onClick={event => handleMenuItemClick(event, index)}
                    >
                      {option.loading ? <SpinningCircle /> : null}
                      {option.label}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};
